import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { loginUser, logoutUser, getProfile } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        // console.log("Token dari LocalStorage:", token);
        if (token) {
          const userData = await getProfile();
          setUser(userData);
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        localStorage.removeItem('token');
        setUser(null);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const login = async (credentials) => {
    try {
      setLoading(true);
      const response = await loginUser(credentials);
      const { token, user: userData } = response.data.data;
        // console.log('response.data.data 0 :', response.data.data);    
        // console.log('Token diterima 0 :', token);    
        // console.log('userData diterima 0 :', userData);    
      // DEBUG: ganti dengan nilai token dari data token auth/login authService 6
      // localStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE4LCJ1c2VybmFtZSI6ImFkbWluNCIsInJvbGUiOiJhZG1pbiIsImlhdCI6MTc1NDIxMzE3OCwiZXhwIjoxNzU0Mjk5NTc4fQ.1CgH9ymlyy1_ffCKKQ98O4U-WTvxCV8qWd35Li_yiy0');
      localStorage.setItem('token', token);

      //debug
      // console.log('Token diterima 1:', token);

      setUser(userData);
      setIsAuthenticated(true);
      
      toast.success('Login berhasil!');
      return response;
    } catch (error) {
      console.error('Login error:', error);
      const message = error.response?.data?.message || 'Login gagal. Silakan coba lagi.';
      toast.error(message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await logoutUser();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      setUser(null);
      setIsAuthenticated(false);
      toast.success('Logout berhasil!');
    }
  };

  const updateUser = (userData) => {
    setUser(userData);
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    updateUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 